import Vue from 'vue'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

VXETable.setup({
  size:'mini'
})

Vue.use(VXETable)